






import { Component, Vue } from "vue-property-decorator";
import { UserLoginStats, getUserLoginStats } from "../api";
import { namespace } from "vuex-class";

import UserStatsTable from "../components/UserStatsTable.vue";

const snackStore = namespace("snackbar");
@Component({
  components: { UserStatsTable },
})
export default class LoginStats extends Vue {
  @snackStore.Mutation defaultError!: () => void;

  stats: UserLoginStats[] = [];

  async loadStats(): Promise<void> {
    try {
      this.stats = await getUserLoginStats();
    } catch (e) {
      this.defaultError();
    }
  }

  mounted(): void {
    this.loadStats();
  }
}
